import DataItem from './data-item';
import location from '../app-data/location';

const types = {
  xmlhttprequest: {
    count: 'xhrRequested',
    unsupported: 'unsupportedXhrPercentage',
    duration: 'xhrRequestedTotalTime',
    total: 'totalSizeOfXhrRequested',
    longest: 'xhrRequestLongest'
  },
  script: {
    count: 'scriptsLoaded',
    unsupported: 'unsupportedScriptsPercentage',
    duration: 'scriptsLoadingTotalTime',
    total: 'totalSizeOfScriptsLoaded'
  },
  link: {
    count: 'cssLoaded',
    unsupported: 'unsupportedCssPercentage',
    duration: 'cssLoadingTotalTime',
    total: 'totalSizeOfCssLoaded'
  }
};

const getResourcesByType = (resources, type) => resources.filter(r => type === r.initiatorType);

const countAllResourcesByType = resources => {
  return Object.keys(types).reduce((acc, cur) => {
    const sameTypeResources = getResourcesByType(resources, cur);
    if (types[cur].count) {
      acc[types[cur].count] = getSupportedResourcesCount(sameTypeResources);
    }
    if (types[cur].duration) {
      acc[types[cur].duration] = getResourceLoadDuration(sameTypeResources);
    }
    if (types[cur].longest) {
      acc[types[cur].longest] = getResourceLoadLongestDuration(sameTypeResources);
    }
    if (types[cur].total) {
      acc[types[cur].total] = isTotalSupported(sameTypeResources, 'transferSize') ?
          getTotalSizeOfResource(sameTypeResources) : -1;
    }
    if (types[cur].unsupported) {
      acc[types[cur].unsupported] = getPercentageOfUnsupportedResources(sameTypeResources);
    }
    return acc;
  }, {});
};

function isTotalSupported(resources) {
  // transferSize property is 0 for cached resources and resources which came from cross-origin without 'timing-allow-origin' header
  return resources.length ? resources.some(r => !!r.transferSize) : false;
}

function getTotalSizeOfResource(resources) {
  let counter = 0;
  resources.forEach(r => counter += r.transferSize);
  return counter;
}

function getResourceLoadLongestDuration(resources) {
  if (resources.length === 0) {
    return -1;
  }
  const longest = resources.reduce((acc, cur) => {
    return cur.responseEnd - cur.startTime >= acc.responseEnd - acc.startTime ? cur : acc;
  });

  return longest.responseEnd - longest.startTime;
}

function getResourceLoadDuration(resources) {
  const loadStartStop = {
    startTime: Infinity,
    responseEnd: 0
  };

  resources.forEach(r => {
    if (loadStartStop.startTime > r.startTime) {
      loadStartStop.startTime = r.startTime;
    }
    if (loadStartStop.responseEnd < r.responseEnd) {
      loadStartStop.responseEnd = r.responseEnd;
    }
  });

  return loadStartStop.responseEnd - loadStartStop.startTime;
}

function getSupportedResourcesCount(resources) {
  return resources.length - resources.filter(isResourceUnsupported).length;
}

function getPercentageOfUnsupportedResources(resources) {
  const totalCount = resources.length;
  if (totalCount === 0) {
    return 0;
  }
  const unsupportedCount = resources.filter(isResourceUnsupported).length;
  return Math.round(unsupportedCount * 100 / totalCount);
}

function isResourceUnsupported(resource) {
  return isCORS(resource.name) && resource.transferSize === 0 && resource.requestStart === 0;
}

function isCORS(resourceName) {
  const host = location.getHost();
  return !!host && !resourceName.includes(host);
}

export default class ResourceDataItem extends DataItem {
  constructor(resources) {
    super(countAllResourcesByType(resources));
  }

  prettyLocalReport() {
    if (console.debug) {
      console.debug(JSON.stringify(this.data, null, 4)/*new ResourceDataItem(resources).export()*/);
    }
  }
}



// WEBPACK FOOTER //
// ./data-items/resource-item.js